import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioDatePackageSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioDatePackageSettingsEntity
